export default __webpack_public_path__ + "static/media/CurriculamPage.e88f8674.png";